import { remittanceErrorFragment } from "@saleor/fragments/errors";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  EnableAllMallRemittance,
  EnableAllMallRemittanceVariables
} from "./types/EnableAllMallRemittance";
import {
  EnableSingleMallRemittance,
  EnableSingleMallRemittanceVariables
} from "./types/EnableSingleMallRemittance";
import {
  SetDailyRemittanceConfig,
  SetDailyRemittanceConfigVariables
} from "./types/SetDailyRemittanceConfig";

export const setDailyRemittanceConfig = gql`
  ${remittanceErrorFragment}
  mutation SetDailyRemittanceConfig(
    $mallId: ID!
    $input: RemittanceConfigUpdateInput!
  ) {
    setDailyRemittanceConfig(mallId: $mallId, input: $input) {
      errors: remittanceErrors {
        ...RemittanceErrorFragment
      }
      remittanceConfig {
        codLimit
        dailyNotifTimes
        reminderIsActive
        minRemittanceLimit
      }
    }
  }
`;
export const useSetDailyRemittanceConfig = makeMutation<
  SetDailyRemittanceConfig,
  SetDailyRemittanceConfigVariables
>(setDailyRemittanceConfig);

export const enableAllMallRemittance = gql`
  ${remittanceErrorFragment}
  mutation EnableAllMallRemittance($enable: Boolean!) {
    enableAllMallRemittance(enable: $enable) {
      errors: remittanceErrors {
        ...RemittanceErrorFragment
      }
      malls {
        id
        name
        remittanceConfig {
          id
          dailyNotifTimes
          isEnable
        }
      }
    }
  }
`;
export const useEnableAllMallRemittance = makeMutation<
  EnableAllMallRemittance,
  EnableAllMallRemittanceVariables
>(enableAllMallRemittance);

export const enableSingleMallRemittance = gql`
  ${remittanceErrorFragment}
  mutation EnableSingleMallRemittance($mallId: ID!, $enable: Boolean!) {
    enableMallRemittance(mallId: $mallId, enable: $enable) {
      errors: remittanceErrors {
        ...RemittanceErrorFragment
      }
      mall {
        name
        remittanceConfig {
          id
          dailyNotifTimes
          codLimit
          isEnable
        }
      }
    }
  }
`;
export const useEnableSingleMallRemittance = makeMutation<
  EnableSingleMallRemittance,
  EnableSingleMallRemittanceVariables
>(enableSingleMallRemittance);
